"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
function Textarea(_a) {
    var label = _a.label, name = _a.name, rest = __rest(_a, ["label", "name"]);
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: name, className: styles_module_scss_1.default.label }, { children: [label, (0, jsx_runtime_1.jsx)("textarea", __assign({ className: styles_module_scss_1.default.input, id: name, name: name }, rest))] })));
}
exports.default = (0, react_1.memo)(Textarea);
